import jQuery from 'jquery';

import attributionSourceExportTemplateUrl from '../excelTemplates/attributionSourceExport.html';

const TEMPLATES = {
  ATTRIBUTION_SOURCE_EXPORT: attributionSourceExportTemplateUrl
};

function DocumentDownloadServiceFn($q, $http, $compile, $rootScope, $timeout, templateService) {
  class DocumentDownloadService {
    get TEMPLATES() { //eslint-disable-line
      return TEMPLATES;
    }

    /**
     * @param {String} template
     * @param {Object} data
     * @param {String} fileName
     */
    downloadExcel(template, data, filename) { //eslint-disable-line
      if (!template) throw new Error('documentDownloadService - downloadExcel() - template is required');
      if (!data) throw new Error('documentDownloadService - downloadExcel() - data');

      return $q((resolve, reject) => {
        templateService.compileTemplate(template, data)
          .then(compiledHtml => {
            const $wrapper = jQuery('<div>');

            $wrapper.append(compiledHtml);

            const content = $wrapper.html();

            filename = filename || 'nightpro-excel-export';

            _download(filename, content);

            return resolve(null);
          })
          .catch(reject);
      });
    }
  }

  /**
   * @param {String} filename
   * @param {String} content
   */
  function _download(filename, content) {
    if (!filename) throw new Error('documentDownloadService - _download() - filename is required');
    if (!content) throw new Error('documentDownloadService - _download() - content is required');

    const data = {
      doc: {
        test: false,
        document_type: 'xls',
        name: filename,
        document_content: content,
        strict: 'none'
      },
      //TODO: don't hard code this
      user_credentials: 'TEPvQlFRdhdTogRI5da4'
    };

    _sendForm('http://docraptor.com/docs.pdf', data);
  }

  function _sendForm(url, data) {
    jQuery('<form style="display: none" id="dr_submission" action="' + url + '" method="post">' + '</form>').appendTo('body'); //eslint-disable-line

    //credentials
    jQuery('form#dr_submission').append('<textarea name="user_credentials"></textarea>');
    jQuery('form#dr_submission textarea[name=user_credentials]').val(data.user_credentials);

    //doc values
    for (let key in data.doc) { //eslint-disable-line
      jQuery('form#dr_submission').append('<textarea name="doc[' + key + ']"></textarea>'); //eslint-disable-line
      jQuery('form#dr_submission textarea[name="doc[' + key + ']"]').val(data.doc[key]); //eslint-disable-line
    }

    //submit the form
    jQuery('form#dr_submission').submit().remove();
  }

  return new DocumentDownloadService();
}

DocumentDownloadServiceFn.$inject = [
  '$q',
  '$http',
  '$compile',
  '$rootScope',
  '$timeout',
  'templateService'
];

export default DocumentDownloadServiceFn;



// WEBPACK FOOTER //
// ./src/services/documentDownloadService.js